<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="breadcrumb-title mb-3 mt-1">
        <div class="d-flex justify-content-start align-items-center gap-2 flex-wrap">
          <mat-icon color="primary">dashboard_2</mat-icon>
          <p class="mb-0">{{ "COMMON.APPDASHBORD" | translate }}</p>
          <mat-icon
            class="cursor-pointer ms-1"
            color="primary"
            matTooltip="PDF"
            matTooltipPosition="right"
            (click)="captureScreen()"
          >
            picture_as_pdf
          </mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div
        *ngIf="applicationname !== 'SUPOSHIT DAHOD WORKER'; else dahodDashboard"
        class="row"
        id="pdfmake"
      >

        <!-- ✅ CASE 1: Sirf 1 Dashboard, koi Report nahi -->
        <ng-container *ngIf="formList.length === 1 && reportList.length === 0">
          <div class="col-12 full-height-card">
            <app-dashboard-charts
              [tittle]="formList[0]['title']"
              [tab_index]="0"
              [attributesList]="formList[0]['fields']"
              [userstoryId]="formList[0]['userstoryId']"
              [formId]="formList[0]['id']"
              [appId]="formList[0]['appId']"
              [loadDelay]="0"
              oneRecord="1"
            ></app-dashboard-charts>
          </div>
        </ng-container>

        <!-- ✅ CASE 2: Sirf 1 Report, koi Dashboard nahi -->
        <ng-container *ngIf="formList.length === 0 && reportList.length === 1">
          <div class="col-12 full-height-card">
            <div class="card radius-10 h-100">
              <div class="card-header bg-white">
                <h6 class="m-0 p-2">{{ reportList[0].title }}</h6>
              </div>
              <div class="card-body p-1 h-100">
                <app-view-report
                  [flag]="true"
                  [searchdata]="reportList[0].dataJson"
                  [titlereport]="reportList[0].title"
                  [uiformid]="reportList[0].uiFormId"
                  [searchList]="reportList[0].searchList"
                  [uiFormData]="reportList[0].dataJson?.data"
                  [autoUpdateReport]="reportList[0].autoUpdateReport"
                ></app-view-report>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ✅ CASE 3: Exactly 1 Dashboard + Exactly 1 Report -->
        <ng-container *ngIf="formList.length === 1 && reportList.length === 1">
          <div class="col-lg-6 mb-1 px-2">
            <app-dashboard-charts
              [tittle]="formList[0]['title']"
              [tab_index]="0"
              [attributesList]="formList[0]['fields']"
              [userstoryId]="formList[0]['userstoryId']"
              [formId]="formList[0]['id']"
              [appId]="formList[0]['appId']"
              [loadDelay]="0"
              oneRecord="1"
            ></app-dashboard-charts>
          </div>
          <div class="col-lg-6 mb-1 px-2">
            <div class="card radius-10 mb-3">
              <div class="card-header bg-white">
                <h6 class="m-0 p-2">{{ reportList[0].title }}</h6>
              </div>
              <div class="card-body p-1">
                <app-view-report
                  [flag]="true"
                  [searchdata]="reportList[0].dataJson"
                  [titlereport]="reportList[0].title"
                  [uiformid]="reportList[0].uiFormId"
                  [searchList]="reportList[0].searchList"
                  [uiFormData]="reportList[0].dataJson?.data"
                  [autoUpdateReport]="reportList[0].autoUpdateReport"
                ></app-view-report>
              </div>
            </div>
          </div>
        </ng-container>

   

        <!-- ✅ CASE 6: Mix - Multiple Dashboards AND/OR Multiple Reports (dono > 0, aur 1+1 nahi) -->
        <ng-container *ngIf="formList.length > 0 && reportList.length > 0 && !(formList.length === 1 && reportList.length === 1)">
          <!-- Dashboards -->
          <div
            *ngFor="let e of formList; let i = index; trackBy: trackByForm"
            class="col-lg-6 mb-1 px-2"
          >
            <app-dashboard-charts
              [tittle]="e['title']"
              [tab_index]="i"
              [attributesList]="e['fields']"
              [userstoryId]="e['userstoryId']"
              [formId]="e['id']"
              [appId]="e['appId']"
              [loadDelay]="getLoadDelay(i)"
            ></app-dashboard-charts>
          </div>
          <!-- Reports -->
          <div *ngFor="let report of reportList" class="col-lg-6 mb-1 px-2">
            <div class="card radius-10 mb-3">
              <div class="card-header bg-white">
                <h6 class="m-0 p-2">{{ report.title }}</h6>
              </div>
              <div class="card-body p-1">
                <app-view-report
                  [flag]="true"
                  [searchdata]="report.dataJson"
                  [titlereport]="report.title"
                  [uiformid]="report.uiFormId"
                  [searchList]="report.searchList"
                  [uiFormData]="report.dataJson?.data"
                  [autoUpdateReport]="report.autoUpdateReport"
                ></app-view-report>
              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

  <ng-template #dahodDashboard>
    <app-dahod-dashboard></app-dahod-dashboard>
  </ng-template>
</div>
